import axios from '@!/lib/axios'
import { buildUrlString } from '@!/Util'

export const searchApi = async (type, searchTerm, page, safeSearch, options, fetchType) => {
  const params = {
    type,
    search_term: searchTerm,
    page,
    safe_search: safeSearch,
    fetch_type: fetchType,
  }

  for (const key in options) {
    params[`options[${key}]`] = options[key]
  }

  const url = buildUrlString('/api/v1/search', params)

  return await axios.get(url)
}
